export const PAYROLL_FREQUENCIES = Object.freeze({
    BI_WEEKLY_26: "Bi-weekly (26 deductions)",
    BI_WEEKLY_24: "Bi-weekly (24 deductions)",
    SEMI_MONTHLY_24: "Semi-monthly (24 deductions)",
    MONTHLY_12: "Monthly",
    WEEKLY_52: "Weekly (52 deductions)",
});
